export enum ProcessingActivityLinkType {
  Default = 0,
  Pinned = 1,
  JointControllerAgreement = 2,
  StandardContractualClause = 3,
}

export class ProcessingActivityLinkDTO {
  linkId: number;

  processingActivityId: number;

  linkTypeId: number;

  linkURLFragment?: string;

  constructor() {
    this.linkId = -1;
    this.processingActivityId = -1;
    this.linkTypeId = 0;
  }
}